import React from 'react';
import I18n from 'utils/I18n';
import clsx from '@strava/ui/clsx';
import { ActionsCancelCircleHighlightedLarge } from '@strava/icons';

import { useCheckoutContext } from '../../../../state/CheckoutContext';
import { postRemovePromoCode } from '../../../../state/Checkout.actions';
import { I18nPrefixPromoButton } from '../../../../shared/constants';

import styles from './RemovePromoIcon.scss';

const RemovePromoIcon = () => {
  const { checkoutEntityState, dispatch } = useCheckoutContext();

  const { packageIds, duration } = checkoutEntityState;

  const handlePostRemovePromoCode = () => {
    const formData = {
      package_ids: packageIds,
      recurring: duration
    };

    postRemovePromoCode(formData, dispatch);
  };

  return (
    <button
      className={clsx('btn', 'btn-link', styles.actionButton)}
      onClick={handlePostRemovePromoCode}
      type="button"
      aria-labelledby="remove-promo-btn"
    >
      <span id="remove-promo-btn" hidden={true}>
        {I18n.t(`${I18nPrefixPromoButton}.remove`)}
      </span>
      <ActionsCancelCircleHighlightedLarge />
    </button>
  );
};

export default RemovePromoIcon;
